export default __webpack_public_path__ + "static/media/ic-help-active.8553ff07.webp";